import { addGlobalValidators } from 'v-for-validation'
import Validator from 'v-for-validation/dist/validators/Validator'

import { DataReport } from 'Core/common/DataReport/types'
import { PreviewSections } from 'Core/interfaces'

import { ReportDataValidation } from './ReportDataValidation'

class ReportDataValidator implements Validator {
	validate(data: DataReport.Basic, fieldName: string, parameters: DataReport.Form) {
		const validation = new ReportDataValidation(data, parameters)
		const result = validation.validate()
		return { ...result }
	}
}

class SqlReportValidation implements Validator {
	validate(data: DataReport.Basic, fieldName: string, { sqlParameters }: DataReport.Form) {
		//no validation for checkbox
		if (data.fieldName === PreviewSections.Checkbox) {
			return { isValid: true }
		}
		const sqslFields = sqlParameters.reduce((acc, par) => {
			if (par.fieldName === PreviewSections.Checkbox) {
				return acc
			}

			if (!par.value && par.isRequired) {
				acc.push(par.label)
			}
			return acc
		}, [] as (string | null | undefined)[])

		return {
			isValid: data.isRequired ? !!data.value : true,
			errMsg: `${sqslFields.join(', ')}`,
			additionalData: { prefix: 'Mandatory' }
		}
	}
}

class ArrayHasElements implements Validator {
	validate(data: []) {
		const isValid = Array.isArray(data) && data.length > 0

		return { isValid }
	}
}

addGlobalValidators([
	{
		name: 'reportDataValidation',
		validator: new ReportDataValidator(),
		errMsg: 'Invalid validation'
	},
	{
		name: 'sqlReportValidation',
		validator: new SqlReportValidation(),
		errMsg: 'Invalid validation'
	},
	{
		name: 'arrayHasElements',
		validator: new ArrayHasElements(),
		errMsg: 'Array is empty'
	}
])
